export const initPromoCodeRoutes = (
    config: any,
    enabled: boolean = true,
) =>
    !enabled
        ? []
        : [
            {
                path: "/manage/promocodes",
                name: "promocode",
                component: () => import("@/pages/manage/promocodes/index.vue"),
                meta: {
                    requiresAuth: true,
                    roles: [
                        config.roles.administrators,
                        config.roles.siteEditors,
                    ],
                },
            },
            {
                path: "/manage/promocodes/:id",
                name: "promocode-id",
                component: () => import("@/pages/manage/promocodes/id.vue"),
                meta: {
                    requiresAuth: true,
                    roles: [
                        config.roles.administrators,
                        config.roles.siteEditors,
                    ],
                },
            },
        ];
